package com.patronat.top.ui.models

data class VenueLocationData(
    val address: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val mapPreviewUrl: String = ""
)
